(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-services-zoho-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    try {
      var f = document.createElement('iframe');
      var ifrmSrc = window.__hsZohoSrc || 'https://forms.zohopublic.ca/wellwise/form/HomeServices/formperma/GvoDSa-PrUN1KDR8-1wwoFbn5Rt2OVm8J22MPo7kaBo?zf_rszfm=1';
      f.src = ifrmSrc;
      f.style.border = 'none';
      f.style.height = '2682px';
      f.style.width = '100%';
      f.style.transition = 'all 0.5s ease';
      f.setAttribute('aria-label', 'Wellwise Home Services contact form');
      var d = document.getElementById('zf_div_HomeServices');
      if (d) { d.appendChild(f); }

      window.addEventListener('message', function (event) {
        var evntData = event.data;
        if (evntData && evntData.constructor == String) {
          var zf_ifrm_data = evntData.split('|');
          if (zf_ifrm_data.length == 2 || zf_ifrm_data.length == 3) {
            var zf_perma = zf_ifrm_data[0];
            var zf_ifrm_ht_nw = parseInt(zf_ifrm_data[1], 10) + 15 + 'px';
            var iframe = document.getElementById('zf_div_HomeServices').getElementsByTagName('iframe')[0];
            if (iframe.src.indexOf('formperma') > 0 && iframe.src.indexOf(zf_perma) > 0) {
              var prevIframeHeight = iframe.style.height;
              var zf_tout = false;
              if (zf_ifrm_data.length == 3) { iframe.scrollIntoView(); zf_tout = true; }
              if (prevIframeHeight != zf_ifrm_ht_nw) {
                if (zf_tout) { setTimeout(function () { iframe.style.height = zf_ifrm_ht_nw; }, 500); }
                else { iframe.style.height = zf_ifrm_ht_nw; }
              }
            }
          }
        }
      }, false);
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();
})();
